var LOCAL_STORAGE_COMPARE_KEY = 'shopify-compare-product';
var LOCAL_STORAGE_DELIMITER = ',';

$(document).ready(function(){
  initCompareGrid();
  compareCount();
});

 document.addEventListener('shopify-compare:updated', function (event) {
      //console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
      initCompareGrid();
    });


$(document).on('click','.add-to-compare',function(){
  productHandle = $(this).attr('data-handle-product');
  updateCompareProducts(productHandle);
  $(this).toggleClass(BUTTON_ACTIVE_CLASS);
  compareCount();
});

var updateCompareProducts = function (handle) {
  var comparelist = getCompareProductList();
      var indexInComparelist = comparelist.indexOf(handle);
      if (indexInComparelist === -1) {
       comparelist.push(handle); 
      }
      else {
       comparelist.splice(indexInComparelist, 1); 
      }
      return setComparelist(comparelist);
};

var initCompareGrid = function () { 
  var grid = document.querySelector(selectors.comparelist_grid) || false;
  if (grid) setupCompareGrid(grid);
};

var setComparelist = function (array) {
  var comparelist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, comparelist);
  else localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);

  var event = new CustomEvent('shopify-compare:updated', {
        detail: { comparelist: array }
      });
      document.dispatchEvent(event);
  
  return comparelist;
};

var getCompareProductList = function () {
  var comparelist = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || false;
  if (comparelist) return comparelist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setupCompareGrid = function (grid) {
  var comparelist = getCompareProductList();
  var requests = comparelist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=compareCard';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    var compareProductCards = responses.join('');
    grid.innerHTML = compareProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();
  });
};
var compareContains = function (handle) {
  var comparelist = getCompareProductList();
  return comparelist.indexOf(handle) !== -1;
};

var compareCount = function () {
      var comparelist = getCompareProductList();
      var count = comparelist.length;
      
      if(count !== 0){
      $('.compare-count-bubble').removeClass('hidden');  
      $('.compare-count-bubble').text(count);  
      }else{
        $('.compare-count-bubble').addClass('hidden');
      }     
}